<template>
  <div class="header">
    <div class="left">
      <div class="left_msg"><img src="@/assets/yklogo.png" alt="" /></div>
      <div class="center"></div>
      <div class="right_msg">
        <div class="texts">
          <span>24年品牌律所</span>
          <span>全球化法律服务机构</span>
        </div>
        <div class="img21"><img src="@/assets/phone/safe.png" alt="" /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTel",
};
</script>

<style lang="scss" scoped>
.header {
  display: none;
}
@media screen and (max-width: 750px) {
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: white;
    height: 5rem;
    .left {
      width: 90%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .center {
        margin: .5rem;
        width: .1rem;
        height: 2rem;
        background: #dfdfdf;
      }
      .left_msg {
        img {
          width: 10rem;
          height: 2rem;
        }
      }
      .right_msg {
        display: flex;
        align-items: center;
        .texts {
          display: flex;
          flex-direction: column;
          span:first-child{
            white-space: nowrap;
            font-weight: bold;
            font-style: oblique;
          }
          span:last-child{
            white-space: nowrap;
            color: #666666;
            font-size: .5rem;
          }
        }
        .img21 {
            margin-left: .8rem;
          img {
            width: 3rem;
          }
        }
      }
    }
  }
}
</style>